import React from 'react'
import { Typography } from '@material-ui/core'

const RoomsHeading = (props) => {
  return <Typography variant='h5'>{props.categories}</Typography>
}

export default RoomsHeading
